(() => {
  const widgetSelector = '.jdgm-all-reviews-widget-v2025';
  const init = () => {
    const loader = document.querySelector('[data-jfl-judgeme-loading]');
    const loaderSection = loader?.closest('.shopify-section');
    const host = loaderSection?.nextElementSibling;
    if (!loader || !loaderSection || !host?.classList.contains('shopify-section--apps') || host.dataset.jflJudgemeLoading === 'true') return;
    host.dataset.jflJudgemeLoading = 'true';
    host.setAttribute('aria-busy', 'true');
    let settleId;
    let readySeen = false;
    let timeoutId;
    const ready = () => host.querySelectorAll('.jm-review-item, .jdgm-rev').length >= 3 && host.querySelector('.jm-review-widget__body') && host.textContent.trim().length > 500;
    const finish = () => {
      clearTimeout(timeoutId);
      observer.disconnect();
      loaderSection.classList.remove('jfl-judgeme-failed');
      loaderSection.classList.add('jfl-judgeme-loaded');
      host.classList.add('jfl-judgeme-loaded');
      host.setAttribute('aria-busy', 'false');
    };
    const consider = () => {
      if (!ready() || readySeen) return;
      readySeen = true;
      settleId = window.setTimeout(finish, 150);
    };
    const observer = new MutationObserver(consider);
    observer.observe(host, { childList: true, subtree: true, characterData: true, attributes: true });
    consider();
    timeoutId = window.setTimeout(() => {
      if (ready()) return finish();
      clearTimeout(settleId);
      host.setAttribute('aria-busy', 'false');
      loaderSection.classList.add('jfl-judgeme-failed');
      loader.innerHTML = '<div class="jfl-judgeme-loading__fallback" data-jfl-judgeme-fallback role="alert"><h2>Reviews are taking longer to load.</h2><p>Please refresh this page in a moment. You can still browse the store while Judge.me reconnects.</p><a href="/pages/reviews">Reload reviews</a></div>';
    }, 20000);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true }); else init();
})();
